<div class="app-global-alert">
    <div *ngIf="isErrorAlertVisible" class="global-message-wrapper">
        <div [ngClass]="messageClassName">
            <span [ngClass]="iconClassName"></span>
            <span data-automation="globalMessage">{{ message.message }}</span>
        </div>
    </div>
</div>
